// Production
export const domain = "https://data.cea.or.th/service";
export const domain_view = "https://data.cea.or.th";
export const url = "https://data.cea.or.th";
export const domainCkan = "https://opendata.cea.or.th";
//UAT
// export const domain_view = "https://ceadata-view.kisrasprint.com/public";
// export const domain = "https://ceadata-backend.kisrasprint.com/public/";
// export const url = "https://ceadata-view.kisrasprint.com/";

// Local
// export const domain = 'http://127.0.0.1:8000';
// export const domain_view = 'http://127.0.0.1:8080';
